/**
 * Trigger a browser file download from a Blob (or BlobPart) via a temporary anchor.
 *
 * Centralizes the object-URL lifecycle so callers don't leak URLs: it always
 * revokes the created object URL after the download is kicked off.
 *
 * @param data     Binary payload. If it's already a Blob (e.g. an axios `responseType: 'blob'`
 *                 response) and no `type` is passed, it's used as-is, preserving its MIME type.
 * @param fileName Suggested download file name (the anchor's `download` attribute).
 * @param type     Optional MIME type used to wrap `data` in a new Blob.
 */
export const downloadBlob = (data: BlobPart | Blob, fileName: string, type?: string): void => {
    const blob = data instanceof Blob && !type ? data : new Blob([data], type ? { type } : undefined);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
